import { createFileRoute } from '@tanstack/react-router';
import { AutomationTestRouteView } from '@/pages/workspaces/automations/[campaignId]/tests/routing';

function AutomationTestRoute() {
  const { campaignId, actionId } = Route.useParams();
  return <AutomationTestRouteView campaignId={campaignId} actionId={actionId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/$actionId',
)({
  component: AutomationTestRoute,
});
